import { useEffect } from "react";
import { useGetExamBaseQuery } from "../../../api";
import LoadingTakeover from "../../buffers/LoadingTakeover";
import { useSystemMessage } from "../../../providers/SystemMessageContext";

import ExamInfoTile from "../../widgets/ExamInfoTile";
import { examBase } from "../../../types";
import { Typography } from "@mui/material";
import "./index.scss";


const ExamCatalog = () => {
    const { showMessage } = useSystemMessage();
    const { data, loading, error } = useGetExamBaseQuery();
    // useEffect(() => {
    //     if (data) {
    //         showMessage(data.message, data.success ? "success" : "error");
    //     }
    // }, [data]);


    if (loading) {
        return (
            <LoadingTakeover />
        )
    } else if (data) {
        const examList = data.data.map((examBase:examBase) => {
            return <ExamInfoTile key={examBase.id} examBase={examBase} />
        });
        return (
            <div className="header">
                <Typography sx={{mb:1, color:'#054fb9', fontWeight:700, textAlign:'left'}} variant="h4">Exams</Typography>
                {examList}
            </div>
        );
    };
};

export default ExamCatalog;